import Text from "../Text";

const widthClass = {
    "1/3": "w-full md:w-1/3",
    "1/2": "w-full md:w-1/2",
    "1/4": "w-full md:w-1/4",
    "full": "w-full",
};

function SellingPointsList({ header, intro, points }) {
    const visible = (points || []).filter((p) => p.show !== false);

    return (
        <div className="w-full">
            {header && (
                <div className="text-3xl text-golden font-bold mb-4">{header}</div>
            )}
            {intro && <div className="text-2xl mb-10">{intro}</div>}

            <div className="flex flex-col md:flex-row md:flex-wrap items-stretch md:gap-4 gap-4">
                {visible.map((p, i) => (
                    <div key={i} className={widthClass[p.width] || "w-full md:w-1/3"}>
                        <Text
                            vertical={true}
                            imgPadding={true}
                            content={
                                <div className="text-blue-dark">
                                    <div className="font-bold">{p.header}</div>
                                    {p.paragraphs?.map((para, j) => (
                                        <div key={j} className="my-4" dangerouslySetInnerHTML={{ __html: para }} />
                                    ))}
                                    {p.zeiten?.map((z, j) => (
                                        <div key={j} className="my-3">
                                            <div>{z.tage}</div>
                                            <div>{z.uhrzeit}</div>
                                        </div>
                                    ))}
                                </div>
                            }
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}

export default SellingPointsList;
